import {
  Clock3,
  Dices,
  Gem,
  Map,
  Puzzle,
  ScanSearch,
  Spade,
  SquareStack,
  LucideIcon,
  CircleAlert,
} from 'lucide-react';
import { cn } from '@ecom/helper-react-class-combine';
import { CategoryMenuItem } from './category-menu-item';
import { NavMenuLink } from '@/features/layout/components/nav-menu-link';
import { useTranslations } from 'next-intl';

type CategoryMeta = {
  icon: LucideIcon;
  gtmId: string;
  href: string;
};

const categoryMetaMap: Record<string, CategoryMeta> = {
  'Hidden Object': {
    icon: ScanSearch,
    gtmId: 'nav_category_hidden_object',
    href: '/c/hidden-object',
  },
  Cards: {
    icon: Spade,
    gtmId: 'nav_category_cards',
    href: '/c/cards',
  },
  'Match 3': {
    icon: Gem,
    gtmId: 'nav_category_match_3',
    href: '/c/match-3',
  },
  Mahjong: {
    icon: SquareStack,
    gtmId: 'nav_category_mahjong',
    href: '/c/mahjong',
  },
  'Time Management': {
    icon: Clock3,
    gtmId: 'nav_category_time_management',
    href: '/c/time-management',
  },
  Puzzle: {
    icon: Puzzle,
    gtmId: 'nav_category_puzzle',
    href: '/c/puzzle',
  },
  Casino: {
    icon: Dices,
    gtmId: 'nav_category_casino',
    href: '/c/casino',
  },
  Adventure: {
    icon: Map,
    gtmId: 'nav_category_adventure',
    href: '/c/adventure',
  },
};

type CategoriesMenuSectionProps = {
  className?: string;
};

export const CategoryMenuSection = ({ className }: CategoriesMenuSectionProps) => {
  const t = useTranslations('Home.header.desktopNavMenu');
  return (
    <section className={cn('bg-background-panel w-fit rounded-md p-4', className)}>
      <div className='grid grid-cols-3 gap-3'>
        {Object.entries(categoryMetaMap).map(([label, meta]) => {
          const Icon = meta?.icon ?? CircleAlert;

          return (
            <CategoryMenuItem
              key={meta.gtmId}
              label={label}
              icon={Icon}
              href={meta.href}
              gtmId={meta.gtmId}
            />
          );
        })}
      </div>

      <NavMenuLink
        href='/categories'
        isMainNav={true}
        ariaLabel='All Categories'
        className='hover:text-text-hover h-[30px] justify-center underline hover:bg-transparent focus:ring-0'
        separator='none'
        data-gtm='cta'
        data-cta-name='nav_category_more_categories'
      >
        {t('navMenuRoutes.moreCategories')}
      </NavMenuLink>
    </section>
  );
};
